module.exports = __webpack_public_path__ + "static/media/avatar6.9272f5ff.png";


//////////////////
// WEBPACK FOOTER
// ./src/avatars/avatar6.png
// module id = 40
// module chunks = 0